"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Calculator, FileText, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AccountingBookkeeping() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="accountingbookkeeping" className="py-24 md:py-32 bg-background">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <div ref={headingRef} className={`transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="text-[36px] md:text-[48px] leading-[1.2] font-bold tracking-[-0.2px] text-foreground mb-6">
              Accounting & Bookkeeping
            </h2>
          </div>

          <div ref={contentRef} className={`transition-all duration-700 ease-out delay-150 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <p className="text-[16px] leading-[1.6] text-muted-foreground mb-8 max-w-2xl mx-auto">Keep your finances organised and compliant with our comprehensive accounting and bookkeeping services. We help businesses of all sizes maintain accurate records, track expenses, and gain valuable insights into their financial health.</p>

            <div className="flex flex-wrap items-center justify-center gap-4 mb-12">
              <Link to="#contact">
                
              </Link>
              <Link to="#">
                
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
              <div data-index={0} className="card text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-[var(--radius-md)] bg-primary-light text-primary mb-4">
                  <Calculator className="size-6" />
                </div>
                <h3 className="text-[22px] leading-[1.5] font-semibold text-foreground mb-2">
                  Accurate Records
                </h3>
                <p className="text-[14px] leading-[1.5] text-muted-foreground">
                  Maintain precise financial records for your business operations
                </p>
              </div>

              <div data-index={1} className="card text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-[var(--radius-md)] bg-primary-light text-primary mb-4">
                  <FileText className="size-6" />
                </div>
                <h3 className="text-[22px] leading-[1.5] font-semibold text-foreground mb-2">
                  Compliance Support
                </h3>
                <p className="text-[14px] leading-[1.5] text-muted-foreground">
                  Stay compliant with all relevant financial regulations
                </p>
              </div>

              <div data-index={2} className="card text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-[var(--radius-md)] bg-primary-light text-primary mb-4">
                  <TrendingUp className="size-6" />
                </div>
                <h3 className="text-[22px] leading-[1.5] font-semibold text-foreground mb-2">
                  Financial Insights
                </h3>
                <p className="text-[14px] leading-[1.5] text-muted-foreground">
                  Gain valuable insights to drive informed business decisions
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}